import {ChangeDetectorRef, Component, Input, ViewChild} from '@angular/core';
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {SessionActions} from "../../../shared/actions/session.actions";
import {Depot} from "../../../shared/view-model/store-management/depot.type";
import {AdministrationUnit} from "../../../shared/view-model/organization/administration-unit.type";
import {FormArray} from "@angular/forms";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";

@Component({
  selector: 'vb-stock-rearrangement-list',
  templateUrl: './stock-rearrangement-list.component.html',
  styleUrls: ['./stock-rearrangement-list.component.css']
})
export class StockRearrangementListComponent extends AbstractListView {

  @Input()
  targetDepot: Depot;

  @Input()
  sourceAdminUnit: AdministrationUnit;

  @Input()
  control: FormArray;

  messages = {
    emptyMessage: 'Keine Artikel',
    totalMessage: 'Artikel insgesamt'
  };

  @ViewChild('deliveryItemsTable')
  table: DatatableComponent;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
  }


  ngOnInit(): void {
    super.ngOnInit();
  }

  onCellUpdate(row, res, index) {
  }
}



// WEBPACK FOOTER //
// ./src/app/store-management/stock-rearrangement/stock-rearrangement-list/stock-rearrangement-list.component.ts